<h2 mat-dialog-title class="mb-0">Move to My Boards</h2>
<button mat-flat-button [mat-dialog-close] mat-dialog-close>
    <img src="assets/icon-close.svg" width="14" height="auto" alt="close button" />
</button>

<div class="board-demote">
    <p class="board-demote__intro">
        This moves <strong>{{ data.boardData.board_name }}</strong> out of
        {{ useBrandivioBranding ? 'Company' : 'Pattern' }} boards and into your own My Boards. Everyone else will lose
        access to it.
    </p>
</div>

<mat-dialog-actions align="center">
    <button mat-stroked-button color="accent" [mat-dialog-close] class="mr-3" mat-dialog-close>Cancel</button>
    <!-- Stroked, not flat: a flat button inside .mat-dialog-container is absolutely positioned
         top-right by the dashboard styles, which is reserved for the close icon. -->
    <button mat-stroked-button color="accent" (click)="demoteBoard()">Demote</button>
</mat-dialog-actions>
